import { render, staticRenderFns } from "./physicalModelInfo.vue?vue&type=template&id=2dc74874&scoped=true&"
import script from "./physicalModelInfo.vue?vue&type=script&lang=js&"
export * from "./physicalModelInfo.vue?vue&type=script&lang=js&"
import style0 from "./physicalModelInfo.vue?vue&type=style&index=0&id=2dc74874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc74874",
  null
  
)

export default component.exports